import { FormControl, FormGroup, Validators } from '@angular/forms';
import { cinema1ValidationPattern } from '@lib/core';
import { RefundItemsFormBuilderInterface, RefundItemsFormDataBuilderInterface } from '@lib/shared';

export class FormBuilder implements RefundItemsFormBuilderInterface {
  public getForm(data: RefundItemsFormDataBuilderInterface): FormGroup {
    return new FormGroup({
      bookingId: new FormControl(data.bookingNo, [Validators.required]),
      email: new FormControl(data.email, [Validators.required, Validators.pattern(cinema1ValidationPattern.email)])
    });
  }
}
